export default {"src":"https://s91588.cdn.ngenix.net/affiliates-frontend/_next/static/media/payment.3b979368.svg","height":320,"width":450};